import { formatEndpoint } from './configureHttp';

export const GetGlobalSSEUrl = (): string =>formatEndpoint('/v1.0/common-io')
